import styled from '@emotion/styled';
import { Checkbox } from 'antd';
import React from 'react';

import { mediaQueries } from 'src/shared/styles/variables';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

interface StyledRadioProps {
    nowrap: number;
    inLine?: boolean;
}

const StyledRadio = styled(Checkbox)<StyledRadioProps>(({ nowrap, inLine }) => ({
    '&.ant-checkbox-wrapper': {
        paddingRight: inLine ? '1rem' : '0rem',
        marginBottom: 0,
        display: inLine ? 'inline-flex' : 'initial',
        flexFlow: inLine ? 'column-reverse' : 'none',
        [mediaQueries.sm]: {
            marginBottom: '1rem',
            display: 'initial',
        },
        '& .ant-checkbox': {
            paddingLeft: inLine ? '0.25rem' : '0rem',
        },
        '& + .ant-checkbox-wrapper': {
            marginLeft: inLine ? '0rem' : '2rem',
            [mediaQueries.sm]: {
                width: nowrap ? 'auto' : '100%',
                marginLeft: nowrap ? '1rem' : 0,
            },
        },
        '& .ant-checkbox-inner': {
            borderRadius: '100%',
            width: 18,
            height: 18,
            '&:after': {
                left: 5,
                top: 7,
            },
        },
        '& .ant-checkbox-checked:after': {
            borderRadius: '100%',
        },
    },
}));

interface CheckboxRadioProps {
    label: string;
    value: string | number;
    onChange: (value: string | number) => void;
    checked?: boolean;
    noWrap?: boolean;
    inLine?: boolean;
}

export class CheckboxRadio extends React.PureComponent<CheckboxRadioProps> {
    private handleOnChange = (_e: CheckboxChangeEvent) => {
        this.props.onChange(this.props.value);
    };

    public render(): JSX.Element {
        const { checked, label, noWrap, inLine } = this.props;

        return (
            <StyledRadio
                nowrap={noWrap ? 1 : 0}
                checked={checked}
                inLine={inLine}
                onChange={this.handleOnChange}
            >
                {label}
            </StyledRadio>
        );
    }
}
